const useClickOutside = (elem, callback) => {
    const outsideClickListener = event => {
        if (!elem.contains(event.target)) {
            callback()
        }
    }

    document.addEventListener('click', outsideClickListener)
}